// extracted by mini-css-extract-plugin
export default {"title":"styles_title__Q6CuK","button-wrapper":"styles_button-wrapper__A3OJV"};